import { connect, bindActionCreators } from '../dependencies';

import { toggleLeftPanel } from '../services/actions';
import Header from '../components/Header';

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            onOpenPanel: () => toggleLeftPanel(true),
        },
        dispatch,
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Header);
